<p>shared-info-dialog works!</p>
